import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ProfileType } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBadge',
  props: {
    profileType: null,
    customProfileType: null
  },
  setup(__props: any) {

const props = __props as {
	profileType?: ProfileType | null | undefined;
	customProfileType?: string | null | undefined;
};



const { tc } = useI18n();

const showBadge = computed(() => props.profileType !== 'USER');

const specialProfileTypes = [
	ProfileType.Actor,
	ProfileType.Director,
	ProfileType.Influencer,
	ProfileType.Producer,
	ProfileType.Vip,
];

const profileTypeMapping: Record<ProfileType, string> = {
	ACTOR: tc('WEBAPP_ACTOR'),
	DIRECTOR: tc('WEBAPP_DIRECTOR'),
	INFLUENCER: tc('WEBAPP_INFLUENCER'),
	JW_EDITOR: tc('WEBAPP_JUSTWATCH_EDITOR'),
	JW_EMPLOYEE: tc('WEBAPP_JUSTWATCH_EMPLOYEE'),
	PRODUCER: tc('WEBAPP_PRODUCER'),
	PRO_USER: 'Pro',
	USER: '',
	WRITER: tc('WEBAPP_WRITER'),
	VIP: tc('WEBAPP_VIP'),
};

const isSpecial = computed(() => {
	if (props.customProfileType) return true;

	return props.profileType != null && specialProfileTypes.includes(props.profileType);
});

const isProUser = computed(() => props.profileType === ProfileType.ProUser);

const displayRole = computed(() => {
	if (props.customProfileType) return props.customProfileType;

	return props.profileType ? profileTypeMapping[props.profileType] : tc('WEBAPP_JUSTWATCH_EDITOR');
});

return { __sfc: true,props, tc, showBadge, specialProfileTypes, profileTypeMapping, isSpecial, isProUser, displayRole }
}

})